export default {
  welcome: "Welcome to the Mily's Beauty Salon",
  save: "Save",
  cancel: "Cancel",
  stylist: "Stylist",
  close: "Close",
  login: {
    title: "Welcome to Mily's Beauty Salon",
    subtitle: "Please log in to continue",
    username: "Username",
    password: "Password",
    button: "Login",
    error: "Incorrect username or password",
    changePassword: "Set a new password",
    changePasswordMsg:
      "For security, you must change your default assigned password.",
    newPassword: "New password",
    newPasswordRules: "Enter the new password",
    confirmPassword: "Confirm password",
    confirmPasswordRules: "Passwords do not match",
    savePassword: "Save new password",
    submitChagePasswordError1: "You must fill in both fields",
    submitChagePasswordError2: "Passwords do not match",
    submitChagePasswordError3: "Password must be at least 6 characters long",
    submitChagePasswordSuccess: "Password changed successfully",
    submitChagePasswordError: "Error changing password, please try again",
  },
  sidebar: {
    dashboard: "Dashboard",
    users: "Stylists",
    clients: "Clients",
    services: "Services",
    queue: "Virtual Queue",
    attention: "Procedures",
    analytics: "Analytics",
    changePassword: "Change password",
    logout: "Log out",
    currentPassword: "Current password",
    newPassword: "New password",
    confirmNewPassword: "Confirm new password",
    fillAllFields: "Fill in all fields.",
    passwordMismatch: "Passwords do not match.",
    newPasswordLengthError: "New password must be at least 6 characters long.",
    passwordChangedSuccess: "Password changed successfully.",
    serverError: "Server error.",
    user: "User",
  },
  dashboard: {
    welcome: "Welcome to the Beauty Salon",
    attendedToday: "Appointments today",
    newClientsToday: "New clients today",
    revenueMonth: "Revenue this month",
    proceduresPerMonth: "Procedures per month",
    procedureDistribution: "Distribution of procedure types",
    proceduresPerStylist: "Procedures per stylist (30 days)",
    avgAttentionTime:
      "Average attention time and total appointments per stylist",
    avgTime: "Average time (minutes)",
    totalAttentions: "Total appointments",
    clientsAttendedToday: "Clients attended today",
    attending: "Attending",
    start: "Start",
    end: "End",
    finish: "Finish",
    clientsWaiting: "Clients waiting",
    arrival: "Arrival",
    attend: "Attend",
    onlyOneClientError:
      "You cannot attend more than one client at a time. You must mark the current client as finished first.",
    clientAssignedSuccess: "Client successfully assigned",
    errorLoadingClients: "Error loading clients",
    procedures: "Procedures",
  },
  users: {
    title: "Stylist Management",
    title_mobile: "Stylists",
    newUser: "New Stylist",
    editUser: "Edit Stylist",
    createUser: "Create Stylist",
    name: "Name",
    email: "Email",
    tel: "Phone",
    // role: "Role",
    status: "Status",
    actions: "Actions",
    edit: "Edit",
    activeUser: "Active stylist",
    inactiveUser: "Inactive stylist",
    save: "Save",
    close: "Close",
    fillAllFields: "Please complete all fields.",
    updateSuccess: "User updated successfully.",
    createSuccess: "User created successfully.",
    pinInUse: "The PIN is already in use by another stylist.",
  },
  clients: {
    title: "Client Catalog",
    title_mobile: "Clients",
    newClient: "New Client",
    search: "Search client...",
    edit: "Edit",
    stylist: "Stylist",
    editClient: "Edit Client",
    createClient: "Create Client",
    name: "Name",
    country: "Phone Country",
    phone: "Phone",
    email: "Email",
    save: "Save",
    close: "Close",
    fillAllFields: "Please complete all fields.",
    invalidPhone: "Please enter a valid 10-digit phone number.",
    updateSuccess: "Client updated successfully.",
    createSuccess: "Client created successfully.",
    headers: {
      name: "Name",
      phone: "Phone",
      email: "Email",
      stylist: "Stylist",
      actions: "Actions",
    },
  },
  services: {
    title: "Service Catalog",
    title_mobile: "Services",
    newService: "New Service",
    search: "Search service...",
    edit: "Edit",
    active: "Active",
    inactive: "Inactive",
    editService: "Edit Service",
    createService: "Create Service",
    description: "Description",
    serviceActive: "Service active",
    serviceInactive: "Service inactive",
    save: "Save",
    close: "Close",
    fillDescription: "Please provide a description.",
    updateSuccess: "Service updated successfully.",
    createSuccess: "Service created successfully.",
    headers: {
      description: "Description",
      status: "Status",
      actions: "Actions",
    },
  },
  queue: {
    registerArrival: "Register Client Arrival",
    client: "Client",
    phone: "Phone",
    phonePlaceholder: "e.g. 555-123456",
    selectStylist: "Select a stylist",
    registerButton: "Register Arrival",
    waitingClients: "Waiting Clients",
    tel: "Tel",
    stylist: "Stylist",
    markAttended: "Mark as attended",
    cancelArrival: "Cancel arrival",
    changeStylist: "Change stylist",
    changeStylistTitle: "Change Stylist",
    stylistChangedSuccess: "Stylist updated successfully.",
    attendingClients: "Clients attending",
    noClientsAttending: "No clients are attending.",
    startTime: "Start time",
    finishAttention: "Finish attention",
    attentionFinishedSuccess: "Attention finished successfully.",
    noClientsWaiting: "No clients are waiting.",
    createClientTitle: "Create Client",
    name: "Name",
    email: "Email",
    save: "Save",
    close: "Close",
    clientAlreadyInQueue: "The client is already in the waiting list.",
    arrivalRegisteredSuccess: "Arrival registered successfully.",
    fillAllFields: "Please fill all fields.",
    confirmCancel: "Are you sure you want to cancel this client's arrival?",
    arrivalCanceledSuccess: "Arrival canceled successfully.",
    cannotAttendMultiple:
      "You cannot attend more than 1 client at a time. You must mark the current client as attended first.",
    clientAssignedSuccess: "Client assigned successfully.",
    clientCreatedSuccess: "Client created successfully.",
    clientsAttending: "Client is being attending by {stylist}",
    enterPinTitle: "Enter Stylist PIN",
    pinLabel: "PIN",
    confirm: "Confirm",
    pinRequired: "The PIN is required.",
    invalidPin: "PIN is incorrect. Please try again.",
  },
  attentionList: {
    title: "Procedure List",
    title_mobile: "Procedures",
    newProcedure: "New Procedure",
    search: "Search procedure...",
    view: "View",
    edit: "Edit",
    photoBefore: "Before Photo",
    photoAfter: "After Photo",
    consent: "Consent",
    close: "Close",
    modal: {
      photoBeforeTitle: "Before photo of procedure",
      photoAfterTitle: "After photo of procedure",
      consentTitle: "Consent Letter",
      consentText:
        "I, {clientName}, acknowledge that Mily’s Beauty Salon is not responsible for any liability arising from the procedure performed, voluntarily accepting the possible risks and authorizing the treatment.",
      clientSignature: "Client's signature:",
    },
    headers: {
      client: "Client",
      date: "Date",
      procedure: "Procedure",
      price: "Price",
      retouch: "Retouch",
      photoBefore: "Before Photo",
      photoAfter: "After Photo",
      consent: "Consent",
      actions: "Actions",
    },
  },
  attention: {
    title: "Specialized Attention Record",
    client: "Client",
    datetime: "Date and time",
    service: "Service",
    formula: "Procedure/Formula",
    price: "Price",
    retouchDate: "Estimated retouch date",
    photoBefore: "Before Photo",
    photoAfter: "After Photo",
    return: "Return",
    saveProcedure: "Save Procedure",
    historyTitle: "Procedure History",
    noHistory: "No history for this client.",
    edit: "Edit",
    consent: {
      title: "Informed Consent",
      text: "I, <strong>{clientName}</strong>, acknowledge that Mily’s Beauty Salon is not responsible for any liability arising from the procedure performed, voluntarily accepting the possible risks and authorizing the treatment.",
      clientSignature: "Client's signature:",
      clearSignature: "Clear signature",
      viewSignature: "View signature",
      viewSavedSignature: "View consent signature",
    },
    modal: {
      capturedSignature: "Captured Signature",
      photoBeforeTitle: "Before photo of procedure",
      photoAfterTitle: "After photo of procedure",
      close: "Close",
    },
    alerts: {
      selectClient: "Please select a client.",
      selectDatetime: "Please select a date and time.",
      selectService: "Please select a service.",
      enterFormula: "Please enter the procedure/formula.",
      enterPrice: "Please enter a valid price.",
      selectRetouchDate: "Please select an estimated retouch date.",
      selectPhotoBefore: "Please select a before photo of the procedure.",
      selectPhotoAfter: "Please select an after photo of the procedure.",
      signConsent: "Please sign the consent form before saving.",
      createSuccess: "Procedure registered successfully.",
      updateSuccess: "Procedure finished successfully.",
      loadError: "Could not load the specified procedure.",
    },
    headers: {
      date: "Date",
      procedure: "Procedure",
      price: "Price",
      consent: "Consent",
      retouch: "Retouch",
      actions: "Actions",
      service: "Service",
    },
  },
  analytics: {
    title: "Client Analysis",
    title_mobile: "Analysis",
    newInvitation: "New Invitation",
    visitFrequency: "Visit Frequency",
    view: "View",
    sendMsg: "Send MSG",
    viewHistory: "View History",
    tel: "Tel",
    lastVisit: "Last Visit",
    procedure: "Procedure",
    nextVisit: "Next Visit",
    lastMsg: "Last Msg",
    sendInvitationTitle: "Send Invitation",
    client: "Client",
    message: "Message",
    send: "Send",
    close: "Close",
    invitationsTitle: "Invitations",
    id: "ID",
    defaultMessage:
      "Hi {clientName}, we remind you that your next touch-up is on {nextVisitDate}. We look forward to seeing you at Mily's Beauty Salon! 😊",
    alerts: {
      selectClient: "Please select a client.",
      emptyMessage: "The message cannot be empty.",
      createSuccess: "Invitation created successfully.",
    },
    headers: {
      client: "Client",
      phone: "Phone",
      lastVisit: "Last Visit",
      lastProcedure: "Last Procedure",
      nextVisit: "Next Visit",
      lastMessage: "Last Message",
      invitations: "Invitations",
      invite: "Invite",
    },
    clientHeaders: {
      id: "Id",
      date: "Date",
      message: "Message",
    },
  },
  confirm: {
    title: "Confirm Action",
    confirmBtn: "Confirm",
    cancelBtn: "Cancel",
  },
};
